import * as THREE from 'three'

class RenderItem {
    constructor(id, renderer, position, placedOnFloor, onUpdate, updateReact) {
        this.id = id
        this.Renderer = renderer
        this.name = `renderObject-${this.id}`
        this.onUpdate = onUpdate
        this.updateReact = updateReact
        this.isDeleted = false

        this.metrics = {
            id,
            msStartLoad: null,
            msEndLoad: null,
            msEndFlush: null,
            sFileDownloadTime: null,
            msBasisUniversalTextureTranscodingTime: null,
            msDracoDecompress: null,
            sLoadTime: null,
            sFlushTime: null,
            sTotalTime: null,
            LoadSize: null,
            MeshCompression: null,
            TextureCompression: null,
            MbFileSizeTransferred: null
        }

        this.layer = 0

        this.visible = true
        this.renderObject = null
        this.bbox = new THREE.Box3()
        this.pose = null
        this.placedOnFloor = placedOnFloor

        this.position = position
        this.setPosition(position)
        this.children = []
    }

    getName() {
        return this.name
    }

    getLayer() {
        return this.layer
    }

    setObject(obj) {
        this.renderObject = obj
    }

    unsetObject() {
        this.renderObject = null
    }

    getObject() {
        return this.renderObject
    }

    getPose() {
        return this.pose
    }

    getPosition() {
        return this.position
    }

    setLoadSize(total) {
        this.metrics.LoadSize = total
    }

    getLoadSize() {
        return this.metrics.LoadSize
    }

    refresh2DPosition() {
        this.setPosition(this.position)
        this.children.forEach(child => child.refresh2DPosition())
    }

    // eslint-disable-next-line class-methods-use-this
    update() {
        
    }

    setPosition(xy, options = {}) {
        if (!xy) {
            return false
        }

        if (
            options.enforceBounds
            && (
                xy[0] < 0 || xy[1] < 0
                || xy[0] > this.Renderer.getRenderDimensions()[0]
                || xy[1] > this.Renderer.getRenderDimensions()[1]
            )
        ) {
            return false
        }

        const pose = this.Renderer.generatePose(xy, this.placedOnFloor, this.isRug)
        if (pose) {
            this.position = xy
            this.pose = pose
            return true
        }
        return false
    }

    setVisible(shouldBeVisible) {
        if (this.getObject()) {
            this.getObject().visible = shouldBeVisible
        }
        this.visible = shouldBeVisible
        this.Renderer.onChildUpdate()
    }

    onDragStart() {
        this.Renderer.highlightOn(this.placedOnFloor)
    }

    onDragFinish() {
        this.Renderer.highlightOff()

        this.children.forEach((child) => {
            if (child.onDragFinish) {
                if (child.onDragFinish) {
                    child.onDragFinish()
                }
                if (child.update) {
                    child.update()
                }
                if (child.updateReactSide) {
                    child.updateReactSide()
                }
            }
        })
    }

    addToScene() {
        this.Renderer.addToScene(this)
    }

    addChild(childItem) {
        this.children.push(childItem)
        if (this.renderObject) {
            const threeObject = childItem.getObject()
            this.renderObject.add(threeObject)
        }
    }

    removeChild(childItem) {
        const idx = this.children.indexOf(childItem)
        if (idx > -1) {
            this.children.splice(idx, 1)
        }
        if (this.renderObject) {
            const threeObject = childItem.getObject()
            this.renderObject.remove(threeObject)
        }
    }

    removeFromScene() {
        this.bbox.makeEmpty()
        this.Renderer.removeFromScene(this)
    }

    addJustLoaded() {
        this.Renderer.incrementLoadedItems(this.getLoadSize())
        if (!this.isDeleted) {
            this.addToScene()
            if (this.renderObject) {
                this.children.forEach(childItem => {
                    this.renderObject.add(childItem.getObject())
                })
            }
        }
    }

    endIsNigh() {
        this.Renderer.decrementLoadedItems(this.getLoadSize())
        this.isDeleted = true
        this.removeFromScene()
        this.Renderer.furnitureManager.releaseGlb(this.renderObject)
        // this.disposeResources()
        this.unsetObject()
        this.parent = null
    }

    enableOutline() {
        if (!this.Renderer) {
            return
        }
        this.Renderer.addObjectToOutline(this.renderObject)
    }

    disableOutline() {
        if (!this.Renderer) {
            return
        }
        this.Renderer.removeObjectFromOutline(this.renderObject)
    }
}
export default RenderItem
